var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Raven from 'raven-js';
import { environment } from './../../../environments/environment';
import { SeoAwareBaseComponent } from '../seo/seo-aware-base.component';
var BaseComponent = /** @class */ (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseComponent.prototype.validateRouteDataParams = function (data, names) {
        for (var name_1 in names) {
            if (!data[names[name_1]]) {
                this.reportError(new Error("Route " + names[name_1] + " param is invalid."));
                return false;
            }
        }
        return true;
    };
    BaseComponent.prototype.validateRouteQueryParams = function (params) {
        for (var field in params) {
            if (typeof field === 'number' && !this.checkNumber(field)) {
                this.reportError(new Error("Route " + field + " number param is invalid."));
                return false;
            }
            else {
                if (typeof field === 'string' && !this.checkString(field)) {
                    this.reportError(new Error("Route " + field + " string param is invalid."));
                    return false;
                }
            }
        }
        return true;
    };
    BaseComponent.prototype.checkNumber = function (nr) {
        if (!nr || isNaN(nr) || nr <= 0) {
            return false;
        }
        return true;
    };
    BaseComponent.prototype.checkString = function (str) {
        if (str.length) {
            return true;
        }
        return false;
    };
    BaseComponent.prototype.reportError = function (error) {
        Raven.captureException(error);
        if (!environment.production) {
            console.error(error);
        }
    };
    return BaseComponent;
}(SeoAwareBaseComponent));
export { BaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/base-component.ts.pre-build-optimizer.js